import { Button, Input, Textarea } from '@hydrodigital/design-system';
import React, { useState, useEffect } from 'react';

interface AnnotationFormProps {
	title: string;
	quality?: number;
	comment: string;
	onTitleChange: (title: string) => void;
	onQualityChange?: (quality: number) => void;
	onCommentChange: (comment: string) => void;
	onSave: () => void;
	onCancel: () => void;
	currentQuality?: string | number;
	isSpecialNote?: boolean;
	loading?: boolean;
	disabled?: boolean;
}

const AnnotationForm: React.FC<AnnotationFormProps> = ({
	title,
	quality,
	comment,
	onTitleChange,
	onQualityChange,
	onCommentChange,
	onSave,
	onCancel,
	currentQuality,
	isSpecialNote = false,
	loading = false,
	disabled = false,
}) => {
	const [qualityInput, setQualityInput] = useState(quality !== undefined ? String(quality) : '');

	useEffect(() => {
		if (quality !== undefined) {
			setQualityInput(String(quality));
		}
	}, [quality]);

	return (
		<div className="flex column">
			<span>Title</span>
			<Input
				className="mb-2 mt-1 w-full"
				value={title}
				onChange={(e) => onTitleChange(e.target.value)}
			/>

			{!isSpecialNote && onQualityChange && quality !== undefined && (
				<>
					<span>New quality value</span>
					{currentQuality !== undefined && !isSpecialNote && (
						<span style={{ color: '#858484', fontSize: '13px', marginTop: '4px' }}>
							Current Data Quality: {currentQuality}
						</span>
					)}
					<Input
						className="mb-1 mt-1 w-full"
						type="text"
						inputMode="numeric"
						value={qualityInput}
						onChange={(e) => {
							const raw = e.target.value;
							if (raw === '') {
								setQualityInput('');
								return;
							}
							if (/^\d+$/.test(raw)) {
								const numValue = Number(raw);
								if (numValue >= 0 && numValue <= 10) {
									setQualityInput(raw);
									if (onQualityChange) {
										onQualityChange(numValue);
									}
								}
							}
						}}
						onBlur={() => {
							if (qualityInput === '' && onQualityChange) {
								onQualityChange(0);
								setQualityInput('0');
							}
						}}
					/>
				</>
			)}
			<span>Comment</span>
			<Textarea
				className="mb-1 mt-1"
				value={comment}
				onChange={(e) => onCommentChange(e.target.value)}
			/>
			<div className="flex self-center mt-2">
				<Button
					style={{
						backgroundColor: loading || disabled ? '#9CA3AF' : '#00203C',
						color: 'white',
						opacity: loading || disabled ? 0.6 : 1,
						cursor: loading || disabled ? 'not-allowed' : 'pointer',
					}}
					className="mr-4"
					onClick={loading || disabled ? undefined : onSave}
					label={loading ? 'Saving...' : 'Accept'}
					size="small"
					showIcon={false}
					disabled={loading || disabled}
				/>
				<Button
					onClick={loading ? undefined : onCancel}
					variant="secondary"
					showIcon={false}
					label="Cancel"
					size="small"
					disabled={loading}
				/>
			</div>
		</div>
	);
};

export default AnnotationForm;
